import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "antd";
import PurchaseRequisition from "./Components/PurchaseRequisition";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { route_url } from "swfrontend/AppConfigs";
import TechnicalOffers from "./Components/TechnicalOffers";
import TechnicalReviewers from "./Components/TechnicalReviwers";

const OfferSubmission = ({ history }) => {
    const formRef = useRef();
    const [form] = Form.useForm();

    const [state, setState] = useState({
        uploadFileList: {
        },
        dropdownValues: {
        },
        showProgress: false,
    });

    const setDynamicState = (stateName, data) => {
        setState({
            ...state,
            dropdownValues: {
                ...state.dropdownValues,
                [stateName]: data,
            },
        });
    };

    const setUploadFileList = (fileList) => {
        setState({ ...state, uploadFileList: fileList });
    };

    const fetchDropdownValues = () => {
        // Object.keys(state.dropdownValues).forEach((dropdown) => {
        //   let URL;
        //   let isDependent = [
        //     "MstRCSubCategoryOfDeviation",
        //     "MstRCObservationType",
        //     "MstRCRiskPotential",
        //     "MstRCSourceOfObservation",
        //   ].includes(dropdown);
        //   if (isDependent) {
        //     URL = RC_MASTER_DROPDOWN_API_PATH.replace("{model}", dropdown);
        //   } else {
        //     URL = RC_MASTER_CUSTOM_DROPDOWN_API_PATH.replace("{model}", dropdown);
        //   }
        //   dataProvider
        //     .getDropdownData(URL.replace("{model}", dropdown))
        //     .then((response) => {
        //       if (response.ok) {
        //         response.json().then((responseJson) => {
        //           if (!isDependent) {
        //             responseJson = responseJson.results;
        //           }
        //           setState((prevState) => ({
        //             ...prevState,
        //             dropdownValues: {
        //               ...prevState.dropdownValues,
        //               [dropdown]: responseJson,
        //             },
        //           }));
        //         });
        //       } else {
        //         response.json().then((responseJson) => {
        //           openNotification("error", "Error", responseJson["message"]);
        //         });
        //       }
        //     })
        //     .catch((error) => {
        //       openNotification("error", "Error", "Error connecting server");
        //     });
        // });
    };

    const fetchDependentDropdownValues = async (type) => {
        // try {
        //   const response = await dataProvider.getDependentDropdownData(
        //     RC_MASTER_CUSTOM_DROPDOWN_API_PATH.replace("{model}", type)
        //   );
        //   if (response.ok) {
        //     const responseJson = await response.json();
        //     return responseJson.results;
        //   } else {
        //     const responseJson = await response.json();
        //     openNotification("error", "Error", responseJson["message"]);
        //     throw new Error(responseJson["message"]);
        //   }
        // } catch (error) {
        //   openNotification("error", "Error", "Error connecting server");
        //   throw error;
        // }
    };

    useEffect(() => {
        fetchDropdownValues();
    }, []);

    const onFinish = (values) => {

    };

    const onFinishFailed = (values) => {

    };


    return (
        <>
            <Form
                ref={formRef}
                className="ant-form ant-form-vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                form={form}
                encType="multipart/form-data"
            >
                {/* Section: Location Details */}
                <div className="row form-box">
                    <legend className="form-legend">Purchase Requisition Details</legend>
                    <PurchaseRequisition />
                </div>
                {/* section-2.5 Vendor Details */}
                <div className="row form-box">
                    <legend className="form-legend">Technical Offer Details</legend>
                    <TechnicalOffers />
                </div>
                {/* Section-3: Risk Observations */}
                <div className="row form-box">
                    <legend className="form-legend">Technical Reviewer Selection</legend>
                    <TechnicalReviewers />
                </div>
                <div className="col-lg-12 col-md-12" style={{ textAlign: "right" }}>
                    <Button type="default" style={{color:"white", background:"green"}}>Submit (if all proposals are received)</Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button type="primary">Save (if more proposals awaited)</Button>

                </div>
            </Form>
        </>
    );
};

export default OfferSubmission;
